import { postData } from '../helpers';

/* Logic based on this: https://hptechblogs.com/using-json-web-token-react/ */
class AuthService {
	constructor(domain) {
		if(window.location.host.indexOf("sizing.seakeeper.com") >= 0) {
			this.domain = domain || 'https://api.seakeeper.com';
		} else if(window.location.host.indexOf("sizing-dev.seakeeper.com") >= 0) {
			this.domain = domain || 'https://api-dev.seakeeper.com';
		} else {
			//this.domain = domain || 'http://api.seakeeper.test';
			this.domain = domain || 'http://api2-laravel.seakeeper.test';
		}
		this.fetch = this.fetch.bind(this);
		this.login = this.login.bind(this);
		this.passwordResetRequest = this.passwordResetRequest.bind(this);
	}

	login(formData) {
		// Get a token
		return postData(`${this.domain}/pp-users/login`, formData)
			.then(res => {
				if(res.token) {
					this.setToken(res.token);
				}
				if(res.user) {
					this.setProfile(res.user);
				}

				return Promise.resolve(res);
			});
	}

	logout(){
		// Clear user token and profile data from localStorage
		localStorage.removeItem('loginToken');
		localStorage.removeItem('user');
	}

	loggedIn(){
		// Checks if there is a saved token and it's still valid
		const token = this.getToken();
		return (token !== null);
	}

	setToken(idToken){
		// Saves user token to localStorage
		localStorage.setItem('loginToken', idToken);
	}

	getToken(){
		// Retrieves the user token from localStorage
		return localStorage.getItem('loginToken');
	}

	setProfile(user) {
		localStorage.setItem('user', JSON.stringify(user));
	}

	getProfile() {
		return JSON.parse(localStorage.getItem('user'));
	}

	passwordResetRequest(formData) {
		return postData(`${this.domain}/pp-users/password-reset-request`, formData)
			.then(res => {
				return Promise.resolve(res);
			});
	}

	resetPassword(formData) {
		return postData(`${this.domain}/pp-users/reset-password`, formData)
			.then(res => {
				return Promise.resolve(res);
			});
	}

	_checkStatus(response) {
		// raises an error in case response status is not a success
		if (response.status >= 200 && response.status < 300) {
			return response;
		} else {
			var error = new Error(response.statusText);
			error.response = response;
			throw error;
		}
	}

	fetch(url, options) {
		//url = 'https://grubgrab.kdpreview.com' + url;
		// performs api calls sending the required authentication headers
		const headers = {};

		if (this.loggedIn()){
			headers['X-Auth-Token'] = this.getToken();
		}

		return fetch(this.domain + url, {
			headers,
			...options
		})
		.then(this._checkStatus)
		.then(response => response.json());
	}

	post(url, data) {
		const headers = {};

		if(this.loggedIn()) {
			headers['X-Auth-Token'] = this.getToken();
		}

		return fetch(this.domain + url, {
			headers,
			body: data, // must match 'Content-Type' header
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			redirect: 'follow', // manual, *follow, error
		})
		.then(this._checkStatus)
		.then(response => response.json());
	}
}

export default AuthService;



// WEBPACK FOOTER //
// ./src/utils/AuthService.js